import React from 'react';
import { BaseIcon } from 'components';

export const ClockIcon = (props) => {

  return(
    <BaseIcon props={props} className={`clock-icon ${props.className || ''}`}>
      <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9208 1.18812H2.07921c-.49214 0-.89109.39895-.89109.89109v9.84159c0 .4921.39895.8911.89109.8911h9.84159c.4921 0 .8911-.399.8911-.8911V2.07921c0-.49214-.399-.89109-.8911-.89109zM2.07921 0C.93089 0 0 .9309 0 2.07921v9.84159C0 13.0691.9309 14 2.07921 14h9.84159C13.0691 14 14 13.0691 14 11.9208V2.07921C14 .93089 13.0691 0 11.9208 0H2.07921z" fill="#000"/>
        <path d="M7.60396 2.41584H6.41584v5.32673h4.39606V6.55446H7.60396V2.41584z" fill="#000"/>
      </svg>
    </BaseIcon>
  )
};
